/**
 * OtecDevis - Système de devis natif OTEC
 * Stockage localStorage, zéro dépendance externe
 */
(function () {
  'use strict';

  var STORAGE_KEY = 'otec_devis';
  var UPDATE_EVENT = 'otec:devis:updated';

  function readStore() {
    try {
      var raw = localStorage.getItem(STORAGE_KEY);
      if (!raw) return { items: [] };
      var parsed = JSON.parse(raw);
      if (!parsed || !Array.isArray(parsed.items)) return { items: [] };
      return parsed;
    } catch (e) {
      return { items: [] };
    }
  }

  function writeStore(store) {
    try {
      localStorage.setItem(STORAGE_KEY, JSON.stringify(store));
      document.dispatchEvent(new CustomEvent(UPDATE_EVENT, { detail: store }));
    } catch (e) {
      console.warn('[OtecDevis] writeStore failed', e);
    }
  }

  function findItemIndex(items, variantId) {
    var id = String(variantId);
    for (var i = 0; i < items.length; i++) {
      if (String(items[i].variantId) === id) return i;
    }
    return -1;
  }

  var OtecDevis = {
    add: function (data) {
      if (!data || !data.variantId) return false;
      var store = readStore();
      var idx = findItemIndex(store.items, data.variantId);
      var qty = parseInt(data.quantity, 10) || 1;
      if (idx >= 0) {
        store.items[idx].quantity = (parseInt(store.items[idx].quantity, 10) || 1) + qty;
      } else {
        store.items.push({
          variantId: data.variantId,
          title: data.title || '',
          url: data.url || '',
          image: data.image || '',
          priceTtcCents: parseInt(data.priceTtcCents, 10) || 0,
          quantity: qty
        });
      }
      writeStore(store);
      return true;
    },

    remove: function (variantId) {
      var store = readStore();
      var idx = findItemIndex(store.items, variantId);
      if (idx < 0) return false;
      store.items.splice(idx, 1);
      writeStore(store);
      return true;
    },

    setQuantity: function (variantId, qty) {
      var q = parseInt(qty, 10);
      if (!q || q < 1) {
        return this.remove(variantId);
      }
      var store = readStore();
      var idx = findItemIndex(store.items, variantId);
      if (idx < 0) return false;
      store.items[idx].quantity = q;
      writeStore(store);
      return true;
    },

    clear: function () {
      writeStore({ items: [] });
    },

    getItems: function () {
      return readStore().items.slice();
    },

    getCount: function () {
      var items = readStore().items;
      var total = 0;
      for (var i = 0; i < items.length; i++) {
        total += parseInt(items[i].quantity, 10) || 0;
      }
      return total;
    },

    getTotals: function (taxRate) {
      var rate = parseFloat(taxRate);
      if (isNaN(rate) || rate < 0) rate = 20;
      var items = readStore().items;
      var totalTtcCents = 0;
      for (var i = 0; i < items.length; i++) {
        var qty = parseInt(items[i].quantity, 10) || 0;
        var p = parseInt(items[i].priceTtcCents, 10) || 0;
        totalTtcCents += p * qty;
      }
      var divisor = rate + 100;
      var totalHtCents = Math.round((totalTtcCents * 100) / divisor);
      var totalTvaCents = totalTtcCents - totalHtCents;
      return {
        htCents: totalHtCents,
        tvaCents: totalTvaCents,
        ttcCents: totalTtcCents,
        taxRate: rate
      };
    },

    /* Helpers exposed for rendering */
    computeHtCents: function (priceTtcCents, taxRate) {
      var rate = parseFloat(taxRate);
      if (isNaN(rate) || rate < 0) rate = 20;
      var p = parseInt(priceTtcCents, 10) || 0;
      return Math.round((p * 100) / (rate + 100));
    },

    formatEuro: function (cents) {
      var amount = (parseInt(cents, 10) || 0) / 100;
      try {
        return new Intl.NumberFormat('fr-FR', {
          style: 'currency',
          currency: 'EUR',
          minimumFractionDigits: 2,
          maximumFractionDigits: 2
        }).format(amount);
      } catch (e) {
        return amount.toFixed(2).replace('.', ',') + ' €';
      }
    },

    STORAGE_KEY: STORAGE_KEY,
    UPDATE_EVENT: UPDATE_EVENT
  };

  window.OtecDevis = OtecDevis;

  /* Toast feedback on add — visible, with check icon and link */
  function showToast(productTitle) {
    var existing = document.querySelector('.devis-toast');
    if (existing) existing.remove();
    var count = OtecDevis.getCount();
    var devisUrl = (document.querySelector('.devis-add-button') && document.querySelector('.devis-add-button').dataset.devisUrl) || '/pages/demande-devis';

    var toast = document.createElement('div');
    toast.className = 'devis-toast';
    toast.setAttribute('role', 'status');
    toast.setAttribute('aria-live', 'polite');

    var icon = document.createElement('span');
    icon.className = 'devis-toast__icon';
    icon.setAttribute('aria-hidden', 'true');
    icon.textContent = '✓';

    var content = document.createElement('div');
    content.className = 'devis-toast__content';

    var title = document.createElement('strong');
    title.className = 'devis-toast__title';
    title.textContent = 'Ajouté à votre devis';

    var sub = document.createElement('span');
    sub.className = 'devis-toast__sub';
    sub.textContent = productTitle
      ? productTitle + ' · ' + count + (count > 1 ? ' articles' : ' article')
      : count + (count > 1 ? ' articles dans votre devis' : ' article dans votre devis');

    content.appendChild(title);
    content.appendChild(sub);

    var link = document.createElement('a');
    link.className = 'devis-toast__link';
    link.href = devisUrl;
    link.textContent = 'Voir mon devis →';

    toast.appendChild(icon);
    toast.appendChild(content);
    toast.appendChild(link);
    document.body.appendChild(toast);
    requestAnimationFrame(function () {
      toast.classList.add('is-visible');
    });
    setTimeout(function () {
      toast.classList.remove('is-visible');
      setTimeout(function () { toast.remove(); }, 300);
    }, 4000);
  }

  /* Brief button state change */
  function flashButton(btn) {
    if (!btn || btn.dataset.flashing === '1') return;
    var span = btn.querySelector('span');
    if (!span) return;
    var original = span.textContent;
    btn.dataset.flashing = '1';
    btn.classList.add('is-added');
    span.textContent = '✓ Ajouté au devis';
    setTimeout(function () {
      span.textContent = original;
      btn.classList.remove('is-added');
      btn.dataset.flashing = '';
    }, 1800);
  }

  /* Read the variant and quantity currently selected on the product form,
     falling back to the values rendered on the button */
  function readSelection(btn) {
    var formId = btn.dataset.productForm;
    var form = formId && document.getElementById(formId);
    var variants = [];
    var variantsNode = btn.parentNode && btn.parentNode.querySelector('[data-devis-variants]');
    if (variantsNode) {
      try { variants = JSON.parse(variantsNode.textContent) || []; } catch (e) { variants = []; }
    }
    function findVariant(id) {
      for (var i = 0; i < variants.length; i++) {
        if (String(variants[i].id) === String(id)) return variants[i];
      }
      return null;
    }

    var variantId = btn.dataset.variantId;
    var idInput = form && form.querySelector('input[name="id"]');
    var urlMatch = /[?&]variant=(\d+)/.exec(window.location.search);
    if (idInput && idInput.value) {
      variantId = idInput.value;
    } else if (urlMatch && findVariant(urlMatch[1])) {
      variantId = urlMatch[1];
    }

    var title = btn.dataset.productTitle;
    var price = btn.dataset.productPrice;
    var variant = findVariant(variantId);
    if (variant) {
      title = title + ' - ' + variant.title;
      price = variant.price;
    }

    var qtyInput = formId && document.querySelector('input[name="quantity"][form="' + formId + '"]');
    var quantity = qtyInput ? parseInt(qtyInput.value, 10) : 1;
    if (!quantity || quantity < 1) quantity = 1;

    return { variantId: variantId, title: title, priceTtcCents: price, quantity: quantity };
  }

  /* Delegate click on .devis-add-button — capture phase to beat any other handler */
  document.addEventListener('click', function (ev) {
    var btn = ev.target.closest && ev.target.closest('.devis-add-button');
    if (!btn) return;
    ev.preventDefault();
    ev.stopPropagation();
    if (typeof ev.stopImmediatePropagation === 'function') ev.stopImmediatePropagation();
    var selection = readSelection(btn);
    var data = {
      variantId: selection.variantId,
      title: selection.title,
      url: btn.dataset.productUrl,
      image: btn.dataset.productImage,
      priceTtcCents: selection.priceTtcCents,
      quantity: selection.quantity
    };
    if (OtecDevis.add(data)) {
      showToast(data.title);
      if (window.mpTrack) window.mpTrack('ajout_devis', { variant_id: String(data.variantId), produit: data.title, quantite: data.quantity });
      flashButton(btn);
    }
    return false;
  }, true);

  /* Sync storage across tabs */
  window.addEventListener('storage', function (e) {
    if (e.key === STORAGE_KEY) {
      document.dispatchEvent(new CustomEvent(UPDATE_EVENT, { detail: readStore() }));
    }
  });
})();
